import { GameExperienceState } from '../common-types/GameExperienceState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Game } from '../common-types/GlobalExperienceState.type';

const initialState: GameExperienceState = {
  currentOperation: null,
  currentGameConfiguration: null,
  currentIndex: 0,
  currentShopperExperience: null,
  hasWonCurrentGame: null,
};

export const gameExperienceSlice = createSlice({
  initialState,
  name: 'GameExperience',
  reducers: {
    setCurrentGameConfiguration (state: GameExperienceState, { payload }: PayloadAction<{ data: Game, index: number }>): GameExperienceState {
      return {
        currentOperation: payload.data.operation,
        currentGameConfiguration: payload.data.gameConfiguration,
        currentIndex: payload.index,
        currentShopperExperience: payload.data.experience,
        hasWonCurrentGame: null,
      };
    },
    setGameResult (state: GameExperienceState, { payload }: PayloadAction<boolean>): GameExperienceState {
      return {
        ...state,
        hasWonCurrentGame: payload,
      };
    },
  },
});

const { actions, reducer } = gameExperienceSlice;

export const { setCurrentGameConfiguration, setGameResult } = actions;
export default reducer;
